import React, { Component } from 'react'
import axios from 'axios'
import Single from './single.js';

export default class Archive extends Component {
    constructor(props) {
        super(props)

        this.state = {
            apiURL: "/api/questions/",
            questionsPerPage: 10,
            searchTerm: window.location.hash ? window.location.hash.substr(window.location.hash.indexOf('q=') + 2) : "null",
            pageNumber: window.location.hash ? parseInt(window.location.hash.substr(window.location.hash.indexOf('p=') + 2, window.location.hash.indexOf('q'))) : 1,
            totalResults: 0,
            questions: [],
            loaded: false,
            csrf_token: document.getElementById("csrf_token").value,
            searching: false
        }
        this.timeout = 0;
        this.loadQuestions = this.loadQuestions.bind(this);
        this.handleSearchInput = this.handleSearchInput.bind(this);
        this.renderQuestions = this.renderQuestions.bind(this);
        this.handlePagination = this.handlePagination.bind(this);
        this.managePageHash = this.managePageHash.bind(this);


    }

    //Runs when user clicks any pagination links
    handlePagination(page) {

        //Get the current pagenumber for reference
        let {pageNumber} = this.state;

        //Find out which button they clicked
        switch (page) {
            case "next":
                //Check they're accessing a page number within bounds
                if (pageNumber < Math.ceil(this.state.totalResults / this.state.questionsPerPage)) {
                    //Set the new pagenumber & load new questions from that new offset
                    this.setState((prevState) => ({
                        pageNumber: prevState.pageNumber + 1
                    }), () => {
                        this.loadQuestions();
                    })
                }
                break;
            case "prev":
                if (pageNumber > 0) {
                    this.setState((prevState) => ({
                        pageNumber: prevState.pageNumber - 1
                    }), () => {
                        this.loadQuestions();
                    })
                }
                break;
            default :
                if (page >= 0 && page <= (Math.ceil(this.state.totalResults / this.state.questionsPerPage))) {
                    this.setState({
                        pageNumber: page
                    }, () => {
                        this.loadQuestions();
                    });
                }
                break;
        }
        
        //Scroll back to the top of the screen
        window.scrollTo(0,0);
    }

    //Fires when the user types something in the search bar
    handleSearchInput(event) {
        let searchText = event.target.value;
        if (searchText.length == 0) {
            searchText = "null";
        }
        this.setState({ searchTerm: searchText});

        //Prevent searching the database on every keypress, wait for them to stop searching for 300ms first
        if (this.timeout) clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
            //300ms passed, empty the questions bucket, set the page number back to 1 and load the results
            this.setState({ 
                questions: [],
                totalResults: 0,
                pageNumber:1
            }, () => {
                this.loadQuestions();
            })
        }, 300);
    }

    //Loads questions from API
    loadQuestions() {
        const { apiURL, searchTerm, pageNumber, questionsPerPage } = this.state;
        this.setState({loaded: false});
        axios
            .get(apiURL + searchTerm + "/" + ((pageNumber * questionsPerPage) -10))
            .then(response => {
                this.setState({
                    questions: response.data.data,
                    totalResults: response.data.total,
                    loaded: true,
                })
            })
    }


    //Reads hash on pageload to start on a specific page or with a specific search term
    //Useful when user reads an article and then presses the browser back button
    componentDidMount() {
        if (window.location.hash) {
            let page = parseInt(window.location.hash.substr(window.location.hash.indexOf('p=') + 2, window.location.hash.indexOf('q')))
            
            this.setState({
                pageNumber: page
            }, () => {
                    this.loadQuestions();
            })
        } else {
            this.loadQuestions();
        }
    }

    renderQuestions() {
        //If there's questions, show them on the page
        if (this.state.questions.length > 0) {
            return (
                <div>
                    {this.state.questions.map(function (question, i) {
                        return <Single question={question} key={i} />
                    })}
                </div>
            )

        } else {
            //No questions yet, check if thats because its still loading or if there was no results
            if (!this.state.loaded) {
                return (<div className='directory-spinner'></div>)
            } else if(this.state.loaded && this.state.questions.length == 0) {
                return (<h4> Sorry, no results were found. Try broadening your search query </h4>)
            }
        }
    }

    //Update the page hash as they search/change page
    managePageHash() {
        let pageNumberHash = parseInt(this.state.pageNumber);
        window.location.hash = "p=" + pageNumberHash + "q=" + this.state.searchTerm.toString()
    }

    render() {
        let {pageNumber} = this.state;
        let pageNumbersTotal = Math.ceil(this.state.totalResults / this.state.questionsPerPage) - 1;
        this.managePageHash()
        return (
            <React.Fragment>
            <div>
                <div className="faq_question__search col-12 px-0">
                    <h4 className="mb-2">How can we help?</h4>
                    <input type="text" placeholder="Search our frequently asked questions..." value={this.state.searchTerm == "null" ? "" : this.state.searchTerm}
                        onChange={(event) => {
                            this.handleSearchInput(event)
                            }
                        }
                    />
                    <div className="search-button">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.304 2.27772C10.2677 -0.759241 5.31361 -0.759241 2.27726 2.27772C-0.759088 5.31469 -0.759088 10.2697 2.27726 13.3067C4.98601 16.016 9.22092 16.3117 12.2573 14.1858L17.6748 19.6044C18.2021 20.1319 19.0651 20.1319 19.6004 19.6044C20.1278 19.0769 20.1278 18.2138 19.6004 17.6783L14.183 12.2597C16.3084 9.22278 16.0207 4.99501 13.304 2.27772ZM12.0255 12.028C9.69235 14.3616 5.89691 14.3616 3.56372 12.028C1.23052 9.69431 1.23052 5.8981 3.56372 3.56444C5.89691 1.23077 9.69235 1.23077 12.0255 3.56444C14.3587 5.8981 14.3587 9.69431 12.0255 12.028Z" fill="white" />
                            </svg>
                    </div>
                    {this.state.searchTerm != "null" &&
                    <h5> {this.state.totalResults} result{this.state.totalResults > 1 || this.state.totalResults == 0 ? "s" : ""} found</h5>}
                    <div className="full-rule-soft my-4 px-0"></div>
                </div>
            </div>
            
            {this.renderQuestions()}
            <div className="pagination d-flex justify-content-end">

                    {this.state.pageNumber > 2 &&
                        <a className="col-2" href={"#p=" + parseInt(1) + "q=" + this.state.searchTerm} onClick={(e) => { e.preventDefault(); this.handlePagination(1) }}>
                            First
                        </a>
                    }   

                    {this.state.pageNumber != 1 &&
                        <a className="col-1" href={"#p=" + parseInt(pageNumber - 1) + "q=" + this.state.searchTerm} onClick={(e) => {e.preventDefault(); this.handlePagination("prev") }} rel="prev">
                            <i className="fas fa-chevron-left" aria-hidden="true"></i>
                        </a>
                    }   

                    {this.state.pageNumber > 1 &&
                        <a className="col-1" href={"#p=" + parseInt(pageNumber - 1) + "q=" + this.state.searchTerm} onClick={(e) => {e.preventDefault(); this.handlePagination(this.state.pageNumber - 1) }}>
                        {pageNumber -1}
                        </a>
                    }

                    <a className="col-1 active-page" href={"#p=" + parseInt(pageNumber) + "q=" + this.state.searchTerm}>
                        {pageNumber}
                    </a>

                    {this.state.pageNumber >= 0 && (this.state.pageNumber+1) <= pageNumbersTotal+1 &&
                        <a className="col-1" href={"#p=" + parseInt(pageNumber + 1) + "q=" + this.state.searchTerm} onClick={(e) => {e.preventDefault(); this.handlePagination(this.state.pageNumber+1) }}>
                        {pageNumber +1}
                        </a>
                    }

                    {this.state.pageNumber >= 0 && (this.state.pageNumber+1) <= pageNumbersTotal+1 &&
                        <a className="col-1" href={"#p=" + parseInt(pageNumber+1) + "q=" + this.state.searchTerm} onClick={(e) => {e.preventDefault(); this.handlePagination("next") }} rel="next"> 
                            <i className="fas fa-chevron-right" aria-hidden="true"></i> 
                        </a>
                    }

                    {this.state.pageNumber < pageNumbersTotal && (this.state.pageNumber+1) != pageNumbersTotal &&
                        <a className="col-2" href={"#p=" + parseInt(pageNumbersTotal + 1) + "q=" + this.state.searchTerm} onClick={(e) => { e.preventDefault(); this.handlePagination(pageNumbersTotal+1) }}>
                            Last ({pageNumbersTotal+1})
                        </a>
                    }   
            </div>
            </React.Fragment>
        )
        
    }
}
